<div class="dashboard-body" *ngIf="activeDashboard === 999">
  <div class="dashboard-caption">
    <div class="dashboard-caption-header">
      <div class="dashboard-header">
        <div class="title">
          <h4>Current Orders Status</h4>
        </div>
        <div class="header-over-view">
          <p class="c-blue"><span>56</span> Open</p>
          <p class="c-red"><span>34</span> To be packed</p>
          <p class="c-black"><span>29</span> To be Shipped</p>
        </div>

        <div class="header-actions">
          <div class="select-day">
            <p>Last 7 days</p>
          </div>
          <div class="action-block" *ngIf="allowedDashboards.length > 1">
            <i (click)="dashboardChange('prev')" class="bi bi-arrow-left-circle"></i>
            <i (click)="dashboardChange('next')" class="bi bi-arrow-right-circle"></i>
          </div>
        </div>
      </div>
    </div>

    <div class="dashboard-content">
      <div class="chart-bar">

        <p-chart *ngIf="hasChartData(orderData)" type="bar" height="350px" [data]="orderData"
          [options]="basicOptions"></p-chart>
        <div *ngIf="!hasChartData(orderData)" class="no-data-placeholder"><i class="bi bi-bar-chart"></i><span>No
            Data</span></div>
      </div>

      <div class="bar-chats">
        <div class="bar-1">
          <i class="bi bi-fullscreen" data-toggle="modal" data-target="#exampleModal2" (click)="openChart1()"></i>
          <p-chart *ngIf="hasChartData(PackagingBarData)" type="pie" height="350px" [data]="PackagingBarData"
            [options]="options"></p-chart>
          <div *ngIf="!hasChartData(PackagingBarData)" class="no-data-placeholder"><i
              class="bi bi-bar-chart"></i><span>No Data</span></div>
          <p>Packaging status</p>

        </div>

        <div class="bar-1">
          <i class="bi bi-fullscreen" data-toggle="modal" data-target="#exampleModal" (click)="openChart()"></i>
          <p-chart *ngIf="hasChartData(deliveryBarData)" type="doughnut" height="350px" [data]="deliveryBarData"
            [options]="options1"></p-chart>
          <div *ngIf="!hasChartData(deliveryBarData)" class="no-data-placeholder"><i
              class="bi bi-bar-chart"></i><span>No Data</span></div>
          <p>Delivery status</p>

        </div>
        <div class="bar-1">
          <p-chart *ngIf="hasChartData(data3)" type="bar" height="350px" style="width: 100%;" [data]="data3"
            [options]="options2"></p-chart>
          <div *ngIf="!hasChartData(data3)" class="no-data-placeholder"><i class="bi bi-bar-chart"></i><span>No
              Data</span></div>
        </div>
      </div>

    </div>

  </div>
</div>

<div class="dashboard-body" *ngIf="activeDashboard === 2">
  <div class="dashboard-caption">
    <div class="dashboard-caption-header">
      <div class="dashboard-header">
        <div class="title">
          <h4>Current Tickets Status</h4>
        </div>
        <div class="header-over-view dashboard1">
          <p (click)="dashboardStatus('OPEN')" class="c-blue"><span>{{ticketCounts.openCount}}</span> Open</p>
          <p (click)="dashboardStatus('COMPLETED')" class="c-red"><span>{{ticketCounts.completedCount}}</span> Completed
          </p>
          <p (click)="dashboardStatus('CLOSED')" class="c-black"><span>{{ticketCounts.closedCount}}</span> Closed</p>
        </div>

        <div class="header-actions">
          <div class="select-day">
            <p>Last 7 days</p>
          </div>
          <div class="action-block" *ngIf="allowedDashboards.length > 1">
            <i (click)="dashboardChange('prev')" class="bi bi-arrow-left-circle"></i>
            <i (click)="dashboardChange('next')" class="bi bi-arrow-right-circle"></i>
          </div>
        </div>
      </div>
    </div>

    <div class="dashboard-content">
      <div class="chart-bar">
        <!-- <i class="bi bi-fullscreen"></i> -->

        <p-chart *ngIf="hasChartData(basicData)" type="bar" height="350px" [data]="basicData"
          [options]="basicOptions"></p-chart>
        <div *ngIf="!hasChartData(basicData)" class="no-data-placeholder"><i class="bi bi-bar-chart"></i><span>No
            Data</span></div>
      </div>


      <div class="bar-chats">
        <div class="bar-1">
          <i class="bi bi-fullscreen" data-toggle="modal" data-target="#exampleModal2" (click)="openChart1()"></i>
          <p-chart *ngIf="hasChartData(barData)" type="pie" height="350px" [data]="barData"
            [options]="options"></p-chart>
          <div *ngIf="!hasChartData(barData)" class="no-data-placeholder"><i class="bi bi-bar-chart"></i><span>No
              Data</span></div>
          <p>Task status</p>

        </div>

        <div class="bar-1">
          <i class="bi bi-fullscreen" data-toggle="modal" data-target="#exampleModal" (click)="openChart()"></i>
          <p-chart *ngIf="hasChartData(data1)" type="doughnut" height="350px" [data]="data1"
            [options]="options1"></p-chart>
          <div *ngIf="!hasChartData(data1)" class="no-data-placeholder"><i class="bi bi-bar-chart"></i><span>No
              Data</span></div>
          <p>Service status</p>

        </div>
        <div class="bar-1">
          <p-chart *ngIf="hasChartData(data2)" type="bar" height="350px" style="width: 100%;" [data]="data2"
            [options]="options2"></p-chart>
          <div *ngIf="!hasChartData(data2)" class="no-data-placeholder"><i class="bi bi-bar-chart"></i><span>No
              Data</span></div>
          <p>Prospect status</p>

        </div>
      </div>

    </div>

  </div>
</div>

<div class="dashboard-body" *ngIf="activeDashboard === 999">
  <div class="dashboard-caption">
    <div class="dashboard-caption-header">
      <div class="dashboard-header">
        <div class="title title1">
          <p *ngIf="isMaterialPurchaseAllCounts">Material Purchases </p>
          <p *ngIf="isMaterialIssuesAllCounts">Material Issues </p>
          <p *ngIf="isMaterialTransfersAllCounts">Material Transfers </p>
          <div class="title1-block">
            <i (click)="materialChange('-')" class="bi bi-arrow-left-circle"></i>
            <i (click)="materialChange('+')" class="bi bi-arrow-right-circle"></i>
          </div>
        </div>
        <div class="header-over-view" *ngIf="isMaterialPurchaseAllCounts">
          <p class="c-blue"><span>{{materialPurchaseCounts.receivedCount}}</span> Received</p>
          <p class="c-red"><span>{{materialPurchaseCounts.approvedCount}}</span> Approved</p>
          <p class="c-black"><span>{{materialPurchaseCounts.rejectedCount}}</span> Rejected</p>
        </div>
        <div class="header-over-view" *ngIf="isMaterialIssuesAllCounts">
          <p class="c-blue"><span>{{materialIssuesDayDataCounts.receivedCount}}</span> Received</p>
          <p class="c-red"><span>{{materialIssuesDayDataCounts.approvedCount}}</span> Approved</p>
          <p class="c-black"><span>{{materialIssuesDayDataCounts.rejectedCount}}</span> Rejected</p>
          <p class="c-black"><span>{{materialIssuesDayDataCounts.verifiedCount}}</span> Verified</p>
          <p class="c-black"><span>{{materialIssuesDayDataCounts.issuedCount}}</span> Issued</p>
          <p class="c-black"><span>{{materialIssuesDayDataCounts.deployedCount}}</span> Deployed</p>
        </div>
        <div class="header-over-view" *ngIf="isMaterialTransfersAllCounts">
          <p class="c-blue"><span>{{materialTransfersAllCounts.receivedCount}}</span> Received</p>
          <p class="c-red"><span>{{materialTransfersAllCounts.approvedCount}}</span> Approved</p>
          <p class="c-black"><span>{{materialTransfersAllCounts.rejectedCount}}</span> Rejected</p>
          <p class="c-green"><span>{{materialTransfersAllCounts.verifiedCount}}</span> Verified</p>
        </div>

        <div class="header-actions">
          <div class="select-day">
            <p>Last 7 days</p>
          </div>
          <div class="action-block" *ngIf="allowedDashboards.length > 1">
            <i (click)="dashboardChange('prev')" class="bi bi-arrow-left-circle"></i>
            <i (click)="dashboardChange('next')" class="bi bi-arrow-right-circle"></i>
          </div>
        </div>
      </div>
    </div>

    <div class="dashboard-content">
      <div class="chart-bar" *ngIf="isMaterialPurchaseAllCounts">
        <p-chart *ngIf="hasChartData(materialPurchaseData)" type="bar" height="350px" [data]="materialPurchaseData"
          [options]="basicOptions"></p-chart>
        <div *ngIf="!hasChartData(materialPurchaseData)" class="no-data-placeholder"><i
            class="bi bi-bar-chart"></i><span>No Data</span></div>
      </div>

      <div class="chart-bar" *ngIf="isMaterialIssuesAllCounts">
        <p-chart *ngIf="hasChartData(materialIssuesData)" type="bar" height="350px" [data]="materialIssuesData"
          [options]="basicOptions"></p-chart>
        <div *ngIf="!hasChartData(materialIssuesData)" class="no-data-placeholder"><i
            class="bi bi-bar-chart"></i><span>No Data</span></div>
      </div>

      <div class="chart-bar" *ngIf="isMaterialTransfersAllCounts">
        <p-chart *ngIf="hasChartData(materialTransfersData)" type="bar" height="350px" [data]="materialTransfersData"
          [options]="basicOptions"></p-chart>
        <div *ngIf="!hasChartData(materialTransfersData)" class="no-data-placeholder"><i
            class="bi bi-bar-chart"></i><span>No Data</span></div>
      </div>

      <div class="bar-chats">
        <div class="bar-1">
          <i class="bi bi-fullscreen" data-toggle="modal" data-target="#materialIssuesDetails"
            (click)="openChart1()"></i>
          <p-chart *ngIf="hasChartData(materialIssuesDayDataPie)" type="pie" height="350px"
            [data]="materialIssuesDayDataPie" [options]="options"></p-chart>
          <div *ngIf="!hasChartData(materialIssuesDayDataPie)" class="no-data-placeholder"><i
              class="bi bi-bar-chart"></i><span>No Data</span></div>
          <p>Material Issues</p>
        </div>

        <div class="bar-1">
          <i class="bi bi-fullscreen" data-toggle="modal" data-target="#materialTransfers" (click)="openChart()"></i>
          <p-chart *ngIf="hasChartData(materialTransfersDayDataPie)" type="doughnut" height="350px"
            [data]="materialTransfersDayDataPie" [options]="options1"></p-chart>
          <div *ngIf="!hasChartData(materialTransfersDayDataPie)" class="no-data-placeholder"><i
              class="bi bi-bar-chart"></i><span>No Data</span></div>
          <p>Material Transfers</p>
        </div>
        <div class="bar-1">
          <i class="bi bi-fullscreen" data-toggle="modal" data-target="#materialPurchase" (click)="openChart1()"></i>
          <p-chart *ngIf="hasChartData(materialPurchaseDayDataPie)" type="pie" height="350px"
            [data]="materialPurchaseDayDataPie" [options]="options"></p-chart>
          <div *ngIf="!hasChartData(materialPurchaseDayDataPie)" class="no-data-placeholder"><i
              class="bi bi-bar-chart"></i><span>No Data</span></div>
          <p>Material Purchase</p>
        </div>
      </div>

    </div>

  </div>
</div>


<div class="dashboard-body" *ngIf="activeDashboard === 999">
  <div class="dashboard-caption">
    <div class="dashboard-caption-header">
      <div class="dashboard-header">
        <!-- <div class="title">
            <h4>Assets <span>(Current Value)</span></h4>
          </div>
          <div class="header-over-view1">
            <p class="c-red"><span>{{totalCurrentCost | currency:selectedCurrency.code:'symbol':'1.2-2':selectedCurrency.locale}}</span></p>
            <p class="c-blue"><span>{{totalAssets}}</span> Total No of Assets</p>
          </div> -->

        <div class="asset-values">
          <div class="values">
            <div class="title-name">
              <h4>Assets <span>(Current Value)</span></h4>
            </div>
            <div class="value-count">
              <p class="c-red">{{totalCurrentCost |
                currency:selectedCurrency.code:'symbol':'1.2-2':selectedCurrency.locale}}</p>
            </div>
          </div>

          <div class="values">
            <div class="title-name">
              <h4>Total No of Assets </h4>
            </div>
            <div class="value-count">
              <p class="c-blue">{{totalAssets}}</p>
            </div>
          </div>
        </div>

        <div class="header-actions">
          <div class="currency-block">
            <!-- <select (change)="onCurrencyChange($event)">
                <option value="{{c.code}}" *ngFor="let c of currencies">
                  {{ c.label }}
                </option>
              </select> -->


            <div class="priority-block">
              <p (click)="priorityToggle()" class="priority">{{selectedCurrency.label}}</p>
              <div class="priority-dropdown" [ngClass]="{'priority-dropdown-toggle': currency_dropdown_toggle}">
                <p *ngFor="let c of currencies" (click)="onCurrencyChange(c.code)">{{c.label}}</p>
              </div>
            </div>



            <!-- <p-dropdown [options]="currencies" optionLabel="label" class="w-full md:w-56"></p-dropdown> -->

            <!-- <div class="card flex justify-center">
</div> -->

          </div>


          <div class="header-actions" *ngIf="allowedDashboards.length > 1">
            <!-- <div class="select-day">
              <p>Last 7 days</p>
            </div> -->
            <div class="action-block">
              <i (click)="dashboardChange('prev')" class="bi bi-arrow-left-circle"></i>
              <i (click)="dashboardChange('next')" class="bi bi-arrow-right-circle"></i>
            </div>
          </div>
          <!-- <div class="select-day">
              <p>Last 7 days</p>
            </div> -->
          <!-- <div class="action-block">
              <i (click)="dashboardChange('1')" [ngClass]="{'active_dashboard': dashboard1}" class="bi bi-arrow-left-circle"></i>
              <i (click)="dashboardChange('2')" [ngClass]="{'active_dashboard': dashboard2}" class="bi bi-arrow-right-circle"></i>
            </div> -->
        </div>
      </div>
    </div>

    <div class="dashboard-content">
      <div class="assets-block">
        <div class="asset">
          <div class="asset-header">
            <h4>Asset Groups</h4>
            <!-- <i class="bi bi-fullscreen"></i> -->
          </div>
          <div class="assets-data">
            <div class="asset-data-header">
              <p>Name</p>
              <p>Current Cost</p>
              <p>Original Cost</p>
            </div>
            <div class="asset-data-list" *ngIf="!isLoading && objectGroupList.length != 0">
              <div class="list" *ngFor="let list of objectGroupList">
                <p>{{list.groupName}}</p>
                <p>{{list.currentCost || '--'}}</p>
                <p>{{list.originalCost || '--'}}</p>
              </div>
            </div>
            <div class="loader" *ngIf="isLoading">
              <div class="spinner"></div>
            </div>

            <div class="loader" *ngIf="!isLoading && objectGroupList.length == 0">
              <div class="no-data">
                <img src="assets/no-data-6.png" alt="">
                <p>no data found</p>
              </div>
            </div>
          </div>
        </div>
        <div class="asset">
          <div class="asset-header">
            <h4>Asset Types</h4>
            <!-- <i class="bi bi-fullscreen"></i> -->

          </div>
          <div class="assets-data">
            <div class="asset-data-header">
              <p>Name</p>
              <p>Current Cost</p>
              <p>Original Cost</p>
            </div>
            <div class="asset-data-list" *ngIf="!isLoading && objectTypeList.length != 0">
              <div class="list" *ngFor="let list of objectTypeList">
                <p>{{list.typeName}}</p>
                <p>{{list.currentCost || '--'}}</p>
                <p>{{list.originalCost || '--'}}</p>
              </div>
            </div>
            <div class="loader" *ngIf="isLoading">
              <div class="spinner"></div>
            </div>

            <div class="loader" *ngIf="!isLoading && objectTypeList.length == 0">
              <div class="no-data">
                <img src="assets/no-data-6.png" alt="">
                <p>no data found</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="bar-chats">


        <div class="bar-1">
          <div class="repair-block">
            <div class="header">
              <h4>Repair Assets – Expected Receipts This Week</h4>
            </div>
            <div class="repair-data">
              <div class="repair-data-header">
                <p>Id</p>
                <p>Name</p>
              </div>
              <div class="repair-data-list">
                <div class="list" *ngFor="let list of objectInfoRepairList">
                  <p>{{list.objectInfoId}}</p>
                  <p>{{list.givenName || '--'}}</p>
                </div>
              </div>
              <div class="loader" *ngIf="isRepairLoading">
                <div class="spinner"></div>
              </div>

              <div class="loader" *ngIf="!isRepairLoading && objectInfoRepairList.length == 0">
                <div class="no-data">
                  <img src="assets/no-data-6.png" alt="">
                  <p>no data found</p>
                </div>
              </div>
            </div>

          </div>
        </div>
        <div class="bar-1">
          <!-- <i class="bi bi-fullscreen"></i> -->
          <p-chart *ngIf="hasChartData(objectConditionCountBarData)" type="bar" height="350px"
            [data]="objectConditionCountBarData" [options]="options"></p-chart>
          <div *ngIf="!hasChartData(objectConditionCountBarData)" class="no-data-placeholder"><i
              class="bi bi-bar-chart"></i><span>No Data</span></div>
          <!-- <p>Asset Condition</p> -->

        </div>
        <div class="bar-1">
          <div class="repair-block">
            <div class="header">
              <h4>Scheduled Maintenance Activities – This Week</h4>
            </div>
            <div class="repair-data">
              <div class="repair-data-header">
                <p>Id</p>
                <p>Name</p>
              </div>
              <div class="repair-data-list">
                <div class="list" *ngFor="let list of maintenanceSchedulesList">
                  <p>{{list.assetId}}</p>
                  <p>{{list.assetName || '--'}}</p>
                </div>
              </div>
              <div class="loader" *ngIf="isMaintenanceSchedulesLoading">
                <div class="spinner"></div>
              </div>

              <div class="loader" *ngIf="!isMaintenanceSchedulesLoading && maintenanceSchedulesList.length == 0">
                <div class="no-data">
                  <img src="assets/no-data-6.png" alt="">
                  <p>no data found</p>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>

    </div>

  </div>
</div>

<div class="dashboard-body" *ngIf="activeDashboard === 12">
  <div class="dashboard-caption">
    <div class="dashboard-caption-header">
      <div class="dashboard-header">
        <div class="title" style="width: 50%;border-right: none">
          <h4>Asset Allocations Dashboard</h4>
        </div>
        <div class="header-actions">
          <div class="action-block" *ngIf="allowedDashboards.length > 1">
            <i (click)="dashboardChange('prev')" class="bi bi-arrow-left-circle"></i>
            <i (click)="dashboardChange('next')" class="bi bi-arrow-right-circle"></i>
          </div>
        </div>
      </div>
    </div>

    <div class="dashboard-content">
      <!-- Allocation Status KPI Cards -->
      <div class="kpi-cards" style="display: flex; justify-content: space-between; margin-bottom: 20px;">
        <div class="kpi-card"
          style="background: #f4f6f9; padding: 15px; border-radius: 8px; text-align: center; width: 18%;">
          <h5>Requested</h5>
          <p style="font-size: 20px; font-weight: bold; color: #4F6D7A;">{{allocationStatus.requested || 0}}</p>
        </div>
        <div class="kpi-card"
          style="background: #f4f6f9; padding: 15px; border-radius: 8px; text-align: center; width: 18%;">
          <h5>Approved</h5>
          <p style="font-size: 20px; font-weight: bold; color: #88B04B;">{{allocationStatus.approved || 0}}</p>
        </div>
        <div class="kpi-card"
          style="background: #f4f6f9; padding: 15px; border-radius: 8px; text-align: center; width: 18%;">
          <h5>Issued</h5>
          <p style="font-size: 20px; font-weight: bold; color: #6B5B95;">{{allocationStatus.issued || 0}}</p>
        </div>
        <div class="kpi-card"
          style="background: #f4f6f9; padding: 15px; border-radius: 8px; text-align: center; width: 18%;">
          <h5>Returned</h5>
          <p style="font-size: 20px; font-weight: bold; color: #F9B24E;">{{allocationStatus.returned || 0}}</p>
        </div>
        <div class="kpi-card"
          style="background: #f4f6f9; padding: 15px; border-radius: 8px; text-align: center; width: 18%;">
          <h5>Rejected</h5>
          <p style="font-size: 20px; font-weight: bold; color: #FF6F61;">{{allocationStatus.rejected || 0}}</p>
        </div>
      </div>

      <!-- Utilization Summary KPI Cards -->
      <div class="bar-chats bar-chats1" style="display: block;">
        <div class="kpi-cards" style="display: flex; justify-content: space-between; margin-bottom: 20px;">
          <div class="kpi-card"
            style="background: #e8f4f8; padding: 15px; border-radius: 8px; text-align: center; width: 31%;">
            <h5>Overall Utilization Rate</h5>
            <p style="font-size: 20px; font-weight: bold; color: #4F6D7A;">
              {{utilizationRateSummary.overallUtilizationRate | percent:'1.2-2'}}</p>
          </div>
          <div class="kpi-card"
            style="background: #e8f4f8; padding: 15px; border-radius: 8px; text-align: center; width: 31%;">
            <h5>Total Available Qty</h5>
            <p style="font-size: 20px; font-weight: bold; color: #88B04B;">{{utilizationRateSummary.totalAvailableQty ||
              0}}</p>
          </div>
          <div class="kpi-card"
            style="background: #e8f4f8; padding: 15px; border-radius: 8px; text-align: center; width: 31%;">
            <h5>Total Allocated Qty</h5>
            <p style="font-size: 20px; font-weight: bold; color: #FF6F61;">{{utilizationRateSummary.totalAllocatedQty ||
              0}}</p>
          </div>
        </div>
      </div>

      <!-- Charts -->
      <div class="bar-chats bar-chats1">
        <div class="bar-1">
          <p-chart *ngIf="hasChartData(allocationsDepartmentChartData)" type="bar" height="350px"
            [data]="allocationsDepartmentChartData" [options]="barOptions"></p-chart>
          <div *ngIf="!hasChartData(allocationsDepartmentChartData)" class="no-data-placeholder"><i
              class="bi bi-bar-chart"></i><span>No Data</span></div>
          <p>Department Utilization</p>
        </div>
        <div class="bar-1">
          <p-chart *ngIf="hasChartData(allocationsBranchChartData)" type="bar" height="350px"
            [data]="allocationsBranchChartData" [options]="barOptions"></p-chart>
          <div *ngIf="!hasChartData(allocationsBranchChartData)" class="no-data-placeholder"><i
              class="bi bi-bar-chart"></i><span>No Data</span></div>
          <p>Branch Utilization</p>
        </div>
      </div>

    </div>
  </div>
</div>


<div class="dashboard-body" *ngIf="activeDashboard === 13">
  <div class="dashboard-caption">
    <div class="dashboard-caption-header">
      <div class="dashboard-header">
        <div class="title" style="width: 50%;border-right: none">
          <h4>Asset Inventory & Financials Dashboard</h4>
        </div>

        <div class="header-actions">
          <div class="action-block" *ngIf="allowedDashboards.length > 1">
            <i (click)="dashboardChange('prev')" class="bi bi-arrow-left-circle"></i>
            <i (click)="dashboardChange('next')" class="bi bi-arrow-right-circle"></i>
          </div>
        </div>
      </div>
    </div>

    <div class="dashboard-content">
      <!-- KPI Cards -->
      <div class="kpi-cards" style="display: flex; justify-content: space-between; margin-bottom: 20px;">
        <div class="kpi-card"
          style="background: #f4f6f9; padding: 15px; border-radius: 8px; text-align: center; width: 18%;">
          <h5>Total Asset Count</h5>
          <p style="font-size: 20px; font-weight: bold; color: #4F6D7A;">{{inventoryKpi.totalAssetCount || 0}}</p>
        </div>
        <div class="kpi-card"
          style="background: #f4f6f9; padding: 15px; border-radius: 8px; text-align: center; width: 18%;">
          <h5>Original Cost</h5>
          <p style="font-size: 20px; font-weight: bold; color: #FF6F61;">{{inventoryKpi.totalOriginalCost |
            currency:selectedCurrency.code:'symbol':'1.2-2':selectedCurrency.locale}}</p>
        </div>
        <div class="kpi-card"
          style="background: #f4f6f9; padding: 15px; border-radius: 8px; text-align: center; width: 18%;">
          <h5>Current Cost</h5>
          <p style="font-size: 20px; font-weight: bold; color: #6B5B95;">{{inventoryKpi.totalCurrentCost |
            currency:selectedCurrency.code:'symbol':'1.2-2':selectedCurrency.locale}}</p>
        </div>
        <div class="kpi-card"
          style="background: #f4f6f9; padding: 15px; border-radius: 8px; text-align: center; width: 18%;">
          <h5>Salvage Value</h5>
          <p style="font-size: 20px; font-weight: bold; color: #88B04B;">{{inventoryKpi.totalSalvageValue |
            currency:selectedCurrency.code:'symbol':'1.2-2':selectedCurrency.locale}}</p>
        </div>
        <div class="kpi-card"
          style="background: #f4f6f9; padding: 15px; border-radius: 8px; text-align: center; width: 18%;">
          <h5>Depreciated Value</h5>
          <p style="font-size: 20px; font-weight: bold; color: #955251;">{{inventoryKpi.depreciatedValue |
            currency:selectedCurrency.code:'symbol':'1.2-2':selectedCurrency.locale}}</p>
        </div>
      </div>

      <div class="bar-chats bar-chats1" style="display: block;">
        <!-- Stock Point Statistics -->
        <div class="kpi-cards" style="display: flex; justify-content: space-between; margin-bottom: 20px;">
          <div class="kpi-card"
            style="background: #e8f4f8; padding: 15px; border-radius: 8px; text-align: center; width: 23%;">
            <h5>In Stock Count</h5>
            <p style="font-size: 20px; font-weight: bold; color: #4F6D7A;">{{inventoryStockPointStats.inStockCount ||
              0}}</p>
          </div>
          <div class="kpi-card"
            style="background: #e8f4f8; padding: 15px; border-radius: 8px; text-align: center; width: 23%;">
            <h5>In Stock Valuation</h5>
            <p style="font-size: 20px; font-weight: bold; color: #FF6F61;">{{inventoryStockPointStats.inStockValuation |
              currency:selectedCurrency.code:'symbol':'1.2-2':selectedCurrency.locale}}</p>
          </div>
          <div class="kpi-card"
            style="background: #f8e8e8; padding: 15px; border-radius: 8px; text-align: center; width: 23%;">
            <h5>Deployed Count</h5>
            <p style="font-size: 20px; font-weight: bold; color: #6B5B95;">{{inventoryStockPointStats.deployedCount ||
              0}}</p>
          </div>
          <div class="kpi-card"
            style="background: #f8e8e8; padding: 15px; border-radius: 8px; text-align: center; width: 23%;">
            <h5>Deployed Valuation</h5>
            <p style="font-size: 20px; font-weight: bold; color: #88B04B;">{{inventoryStockPointStats.deployedValuation
              | currency:selectedCurrency.code:'symbol':'1.2-2':selectedCurrency.locale}}</p>
          </div>
        </div>
      </div>

      <div class="bar-chats bar-chats1">
        <div class="bar-1">
          <p-chart *ngIf="hasChartData(inventoryCategoryChartData)" type="pie" height="350px"
            [data]="inventoryCategoryChartData" [options]="optionsNew"></p-chart>
          <div *ngIf="!hasChartData(inventoryCategoryChartData)" class="no-data-placeholder"><i
              class="bi bi-bar-chart"></i><span>No Data</span></div>
          <p>Category Distribution (Count)</p>
        </div>
        <div class="bar-1">
          <p-chart *ngIf="hasChartData(inventoryMakeChartData)" type="bar" height="350px"
            [data]="inventoryMakeChartData" [options]="barOptions"></p-chart>
          <div *ngIf="!hasChartData(inventoryMakeChartData)" class="no-data-placeholder"><i
              class="bi bi-bar-chart"></i><span>No Data</span></div>
          <p>Make & Model Distribution</p>
        </div>
      </div>

    </div>

  </div>
</div>

<div class="dashboard-body" *ngIf="activeDashboard === 14">
  <div class="dashboard-caption">
    <div class="dashboard-caption-header">
      <div class="dashboard-header">
        <div class="title" style="width: 50%;border-right: none">
          <h4>Asset Logistics & Transit Dashboard</h4>
        </div>

        <div class="header-actions">
          <div class="action-block" *ngIf="allowedDashboards.length > 1">
            <i (click)="dashboardChange('prev')" class="bi bi-arrow-left-circle"></i>
            <i (click)="dashboardChange('next')" class="bi bi-arrow-right-circle"></i>
          </div>
        </div>
      </div>
    </div>

    <div class="dashboard-content">
      <!-- Transit Status Breakdown KPI Cards -->
      <div class="kpi-cards" style="display: flex; justify-content: space-between; margin-bottom: 20px;">
        <div class="kpi-card"
          style="background: #f4f6f9; padding: 15px; border-radius: 8px; text-align: center; width: 23%;">
          <h5>Requested Shipments</h5>
          <p style="font-size: 20px; font-weight: bold; color: #4F6D7A;">{{transitStatusBreakdown.requested || 0}}</p>
        </div>
        <div class="kpi-card"
          style="background: #f4f6f9; padding: 15px; border-radius: 8px; text-align: center; width: 23%;">
          <h5>In Transit</h5>
          <p style="font-size: 20px; font-weight: bold; color: #88B04B;">{{transitStatusBreakdown.inTransit || 0}}</p>
        </div>
        <div class="kpi-card"
          style="background: #f4f6f9; padding: 15px; border-radius: 8px; text-align: center; width: 23%;">
          <h5>Transferred</h5>
          <p style="font-size: 20px; font-weight: bold; color: #6B5B95;">{{transitStatusBreakdown.transferred || 0}}</p>
        </div>
        <div class="kpi-card"
          style="background: #f4f6f9; padding: 15px; border-radius: 8px; text-align: center; width: 23%;">
          <h5>Rejected</h5>
          <p style="font-size: 20px; font-weight: bold; color: #FF6F61;">{{transitStatusBreakdown.rejected || 0}}</p>
        </div>
      </div>

      <div class="bar-chats bar-chats1" style="display: block;">
        <!-- Transit Valuation KPI Cards -->
        <div class="kpi-cards" style="display: flex; justify-content: space-between; margin-bottom: 20px;">
          <div class="kpi-card"
            style="background: #e8f4f8; padding: 15px; border-radius: 8px; text-align: center; width: 48%;">
            <h5>Current In-Transit Asset Count</h5>
            <p style="font-size: 20px; font-weight: bold; color: #4F6D7A;">
              {{transitValuation.currentInTransitCount || 0}}
            </p>
          </div>
          <div class="kpi-card"
            style="background: #f8e8e8; padding: 15px; border-radius: 8px; text-align: center; width: 48%;">
            <h5>Total Transit Asset Value</h5>
            <p style="font-size: 20px; font-weight: bold; color: #FF6F61;">
              {{transitValuation.totalTransitAssetValue |
              currency:selectedCurrency.code:'symbol':'1.2-2':selectedCurrency.locale}}
            </p>
          </div>
        </div>
      </div>

      <div class="bar-chats bar-chats1" style="grid-template-columns: 1fr;">
        <div class="bar-1">
          <p-chart *ngIf="hasChartData(logisticsHighTrafficChartData)" type="bar" height="350px"
            [data]="logisticsHighTrafficChartData" [options]="barOptions"></p-chart>
          <div *ngIf="!hasChartData(logisticsHighTrafficChartData)" class="no-data-placeholder"><i
              class="bi bi-bar-chart"></i><span>No Data</span></div>
          <p>High Traffic Corridors</p>
        </div>
      </div>

    </div>
  </div>
</div>


<div class="dashboard-body" *ngIf="activeDashboard === 15">
  <div class="dashboard-caption">
    <div class="dashboard-caption-header">
      <div class="dashboard-header">
        <div class="title" style="width: 50%;border-right: none">
          <h4>Operational Health & Maintenance Dashboard</h4>
        </div>

        <div class="header-actions">
          <div class="action-block" *ngIf="allowedDashboards.length > 1">
            <i (click)="dashboardChange('prev')" class="bi bi-arrow-left-circle"></i>
            <i (click)="dashboardChange('next')" class="bi-arrow-right-circle bi"></i>
          </div>
        </div>
      </div>
    </div>

    <div class="dashboard-content">
      <!-- Condition Metrics KPI Cards -->
      <div class="kpi-cards" style="display: flex; justify-content: space-between; margin-bottom: 20px;">
        <div class="kpi-card"
          style="background: #f4f6f9; padding: 15px; border-radius: 8px; text-align: center; width: 23%;">
          <h5>Good Assets</h5>
          <p style="font-size: 20px; font-weight: bold; color: #88B04B;">{{operationsConditionMetrics.goodCount || 0}}
          </p>
        </div>
        <div class="kpi-card"
          style="background: #f4f6f9; padding: 15px; border-radius: 8px; text-align: center; width: 23%;">
          <h5>Under Repair</h5>
          <p style="font-size: 20px; font-weight: bold; color: #F9B24E;">{{operationsConditionMetrics.underRepairCount
            || 0}}</p>
        </div>
        <div class="kpi-card"
          style="background: #f4f6f9; padding: 15px; border-radius: 8px; text-align: center; width: 23%;">
          <h5>Faulty Assets</h5>
          <p style="font-size: 20px; font-weight: bold; color: #FF6F61;">{{operationsConditionMetrics.faultyCount || 0}}
          </p>
        </div>
        <div class="kpi-card"
          style="background: #f4f6f9; padding: 15px; border-radius: 8px; text-align: center; width: 23%;">
          <h5>Scrap Assets</h5>
          <p style="font-size: 20px; font-weight: bold; color: #955251;">{{operationsConditionMetrics.scrapCount || 0}}
          </p>
        </div>
      </div>

      <div class="bar-chats bar-chats1" style="display: block;">
        <!-- Repair Pipeline & Monitoring KPI Cards -->
        <div class="kpi-cards" style="display: flex; justify-content: space-between; margin-bottom: 20px;">
          <div class="kpi-card"
            style="background: #e8f4f8; padding: 15px; border-radius: 8px; text-align: center; width: 23%;">
            <h5>Currently In Repair</h5>
            <p style="font-size: 20px; font-weight: bold; color: #4F6D7A;">
              {{operationsRepairPipeline.currentlyInRepairCount || 0}}</p>
          </div>
          <div class="kpi-card"
            style="background: #e8f4f8; padding: 15px; border-radius: 8px; text-align: center; width: 23%;">
            <h5>Total Repair Expenses</h5>
            <p style="font-size: 20px; font-weight: bold; color: #FF6F61;">
              {{operationsRepairPipeline.totalRepairExpenses |
              currency:selectedCurrency.code:'symbol':'1.2-2':selectedCurrency.locale}}</p>
          </div>
          <div class="kpi-card"
            style="background: #f8e8e8; padding: 15px; border-radius: 8px; text-align: center; width: 23%;">
            <h5>Average Repair Days</h5>
            <p style="font-size: 20px; font-weight: bold; color: #6B5B95;">{{operationsRepairPipeline.averageRepairDays
              || 0}}</p>
          </div>
          <div class="kpi-card"
            style="background: #f8e8e8; padding: 15px; border-radius: 8px; text-align: center; width: 23%;">
            <h5>Uptime</h5>
            <p style="font-size: 20px; font-weight: bold; color: #88B04B;">{{operationsMonitoringStats.uptimePercentage
              | number:'1.2-2'}}%</p>
          </div>
        </div>
      </div>

      <div class="bar-chats bar-chats1" style="display: block;">
        <!-- Monitoring Stats & Warranty Alerts KPI Cards -->
        <div class="kpi-cards" style="display: flex; justify-content: space-between; margin-bottom: 20px;">
          <div class="kpi-card"
            style="background: #e8f4f8; padding: 15px; border-radius: 8px; text-align: center; width: 23%;">
            <h5>Monitored Assets</h5>
            <p style="font-size: 20px; font-weight: bold; color: #4F6D7A;">
              {{operationsMonitoringStats.monitoredAssetsCount || 0}}</p>
          </div>
          <div class="kpi-card"
            style="background: #e8f4f8; padding: 15px; border-radius: 8px; text-align: center; width: 23%;">
            <h5>Active Warranty</h5>
            <p style="font-size: 20px; font-weight: bold; color: #88B04B;">
              {{operationsWarrantyAlerts.activeWarrantyCount || 0}}</p>
          </div>
          <div class="kpi-card"
            style="background: #f8e8e8; padding: 15px; border-radius: 8px; text-align: center; width: 23%;">
            <h5>Expired Warranty</h5>
            <p style="font-size: 20px; font-weight: bold; color: #955251;">
              {{operationsWarrantyAlerts.expiredWarrantyCount || 0}}</p>
          </div>
          <div class="kpi-card"
            style="background: #fff3cd; padding: 15px; border-radius: 8px; text-align: center; width: 23%; border: 1px solid #ffeeba;">
            <h5>Expiring in 30 Days</h5>
            <p style="font-size: 20px; font-weight: bold; color: #856404;">
              {{operationsWarrantyAlerts.expiringIn30DaysCount || 0}}</p>
          </div>
        </div>
      </div>

      <div class="bar-chats bar-chats1">
        <div class="bar-1">
          <p-chart *ngIf="hasChartData(operationsOnlineChartData)" type="pie" height="350px"
            [data]="operationsOnlineChartData" [options]="optionsNew"></p-chart>
          <div *ngIf="!hasChartData(operationsOnlineChartData)" class="no-data-placeholder"><i
              class="bi bi-bar-chart"></i><span>No Data</span></div>
          <p>Online vs Offline Assets</p>
        </div>
        <div class="bar-1">
          <p-chart *ngIf="hasChartData(operationsVendorChartData)" type="bar" height="350px"
            [data]="operationsVendorChartData" [options]="barOptions"></p-chart>
          <div *ngIf="!hasChartData(operationsVendorChartData)" class="no-data-placeholder"><i
              class="bi bi-bar-chart"></i><span>No Data</span></div>
          <p>Vendor Distribution (Repairs & Costs)</p>
        </div>
      </div>

    </div>

  </div>
</div>

<div class="modal fade" id="exampleModal" tabindex="-1" data-backdrop="static" aria-labelledby="exampleModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Service Details
          <span data-dismiss="modal">
            <i class="bi bi-x-lg"></i>
          </span>
        </h5>
      </div>
      <div class="modal-body">
        <div class="date">
          <i class="bi bi-arrow-left-circle" (click)="serviceTypeDateArrow('-')"></i>
          <input type="date" (change)="dateChange()" [(ngModel)]="serviceTypeDate">
          <i class="bi bi-arrow-right-circle" (click)="serviceTypeDateArrow('+')"></i>
        </div>
        <div class="service-type-data">
          <table>
            <thead>
              <tr>
                <th style="width: 50%;">Service Type</th>
                <th style="width: 50%;">Ticket Count</th>
              </tr>
            </thead>


            <!-- <tbody *ngIf="!isLoading && serviceTypeData.length != 0">
              <tr *ngFor="let type of serviceTypeData;let i = index">
                <th style="width: 50%;">{{type.serviceType}}</th>
                <th style="width: 50%;">{{type.ticketCount}}</th>
              </tr>
            </tbody> -->
          </table>
          <div class="service-data-table" *ngIf="!isLoading && serviceTypeData != null && serviceTypeData.length != 0">
            <div class="data-service" *ngFor="let type of serviceTypeData;let i = index">
              <p style="width: 50%;">{{type.serviceType}}</p>
              <p style="width: 50%;">{{type.ticketCount}}</p>
            </div>
          </div>


          <div class="loader" *ngIf="isLoading">
            <div class="spinner"></div>
          </div>
          <div class="loader" *ngIf="!isLoading && serviceTypeData.length == 0">
            <div class="no-data">
              <img src="assets/no-data-6.png" alt="">
              <p>no data found</p>
            </div>

          </div>
        </div>

        <div class="modal-footer">
          <button type="button" id="closeModalButton2" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="exampleModal2" tabindex="-1" data-backdrop="static" aria-labelledby="exampleModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Task Details
          <span data-dismiss="modal">
            <i class="bi bi-x-lg"></i>
          </span>
        </h5>
      </div>

      <div class="modal-body">
        <div class="date">
          <i class="bi bi-arrow-left-circle"></i>
          <input type="date" (change)="dateChange()" [(ngModel)]="serviceTypeDate">
          <i class="bi bi-arrow-right-circle"></i>
        </div>
        <div class="service-type-data">
          <table>
            <thead>
              <tr>
                <th style="width: 50%;">Task Status</th>
                <th style="width: 50%;">Task Count</th>
              </tr>
            </thead>


            <!-- <tbody *ngIf="!isLoading && serviceTypeData.length != 0">
              <tr *ngFor="let type of serviceTypeData;let i = index">
                <th style="width: 50%;">{{type.serviceType}}</th>
                <th style="width: 50%;">{{type.ticketCount}}</th>
              </tr>
            </tbody> -->
          </table>
          <div class="service-data-table" *ngIf="!isLoading && serviceTypeData.length != 0">
            <div class="data-service" *ngFor="let task of taskData;let i = index">
              <p style="width: 50%;">{{task.status}}</p>
              <p style="width: 50%;">{{task.count}}</p>
            </div>
          </div>


          <div class="loader" *ngIf="isLoading">
            <div class="spinner"></div>
          </div>
          <div class="loader" *ngIf="!isLoading && serviceTypeData.length == 0">
            <div class="no-data">
              <img src="assets/no-data-6.png" alt="">
              <p>no data found</p>
            </div>

          </div>
        </div>

        <div class="modal-footer">
          <button type="button" id="closeModalButton2" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
        </div>
      </div>
    </div>
  </div>
</div>







<div class="modal fade" id="materialIssuesDetails" tabindex="-1" data-backdrop="static"
  aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Material Issues Details
          <span data-dismiss="modal">
            <i class="bi bi-x-lg"></i>
          </span>
        </h5>
      </div>

      <div class="modal-body">
        <div class="date">
          <i class="bi bi-arrow-left-circle" (click)="materialIssuesDateArrow('-')"></i>
          <input type="date" (change)="materialIssuesDateChange()" [(ngModel)]="materialIssuesDate">
          <i class="bi bi-arrow-right-circle" (click)="materialIssuesDateArrow('+')"></i>
        </div>
        <div class="material-issues-date-data">
          <div>
            <div class="material-issues-date-list">
              <p>Requested</p>
              <p>{{materialIssuesDayDataCounts.requestedCount}}</p>
            </div>
            <div class="material-issues-date-list">
              <p>Received</p>
              <p>{{materialIssuesDayDataCounts.receivedCount}}</p>
            </div>
            <div class="material-issues-date-list">
              <p>Approved</p>
              <p>{{materialIssuesDayDataCounts.approvedCount}}</p>
            </div>
            <div class="material-issues-date-list">
              <p>Rejected </p>
              <p>{{materialIssuesDayDataCounts.rejectedCount}}</p>
            </div>
            <div class="material-issues-date-list">
              <p>Issued </p>
              <p>{{materialIssuesDayDataCounts.issuedCount}}</p>
            </div>
            <div class="material-issues-date-list">
              <p>Deployed </p>
              <p>{{materialIssuesDayDataCounts.deployedCount}}</p>
            </div>
            <div class="material-issues-date-list">
              <p>Verified </p>
              <p>{{materialIssuesDayDataCounts.verifiedCount}}</p>
            </div>
          </div>
        </div>

        <div class="modal-footer">
          <button type="button" id="closeModalButton2" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
        </div>
      </div>
    </div>
  </div>
</div>



<div class="modal fade" id="materialTransfers" tabindex="-1" data-backdrop="static" aria-labelledby="exampleModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Material Transfers Details
          <span data-dismiss="modal">
            <i class="bi bi-x-lg"></i>
          </span>
        </h5>
      </div>

      <div class="modal-body">
        <div class="date">
          <i class="bi bi-arrow-left-circle" (click)="materialTransfersDateArrow('-')"></i>
          <input type="date" (change)="materialIssuesDateChange()" [(ngModel)]="materialTransfersDate">
          <i class="bi bi-arrow-right-circle" (click)="materialTransfersDateArrow('+')"></i>
        </div>
        <div class="material-issues-date-data">
          <div>
            <div class="material-issues-date-list">
              <p>Received</p>
              <p>{{materialTransfersDayDataCounts.receivedCount}}</p>
            </div>
            <div class="material-issues-date-list">
              <p>Approved</p>
              <p>{{materialTransfersDayDataCounts.approvedCount}}</p>
            </div>
            <div class="material-issues-date-list">
              <p>Rejected </p>
              <p>{{materialTransfersDayDataCounts.rejectedCount}}</p>
            </div>
            <div class="material-issues-date-list">
              <p>Verified </p>
              <p>{{materialTransfersDayDataCounts.verifiedCount}}</p>
            </div>
          </div>
        </div>

        <div class="modal-footer">
          <button type="button" id="closeModalButton2" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
        </div>
      </div>
    </div>
  </div>
</div>


<div class="modal fade" id="materialPurchase" tabindex="-1" data-backdrop="static" aria-labelledby="exampleModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Material Purchase Details
          <span data-dismiss="modal">
            <i class="bi bi-x-lg"></i>
          </span>
        </h5>
      </div>

      <div class="modal-body">
        <div class="date">
          <i class="bi bi-arrow-left-circle" (click)="materialPurchaseDateArrow('-')"></i>
          <input type="date" (change)="materialPurchaseDateChange()" [(ngModel)]="materialPurchaseDate">
          <i class="bi bi-arrow-right-circle" (click)="materialPurchaseDateArrow('+')"></i>
        </div>
        <div class="material-issues-date-data">
          <div>
            <div class="material-issues-date-list">
              <p>Received</p>
              <p>{{materialPurchaseDayDataCounts.receivedCount}}</p>
            </div>
            <div class="material-issues-date-list">
              <p>Approved</p>
              <p>{{materialPurchaseDayDataCounts.approvedCount}}</p>
            </div>
            <div class="material-issues-date-list">
              <p>Rejected </p>
              <p>{{materialPurchaseDayDataCounts.rejectedCount}}</p>
            </div>
            <div class="material-issues-date-list">
              <p>Verified </p>
              <p>{{materialPurchaseDayDataCounts.verifiedCount}}</p>
            </div>
          </div>
        </div>

        <div class="modal-footer">
          <button type="button" id="closeModalButton2" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
        </div>
      </div>
    </div>
  </div>
</div>